import { ErrorHandler, Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';

@Injectable()
export class ErrorInterceptor implements ErrorHandler {

    constructor() {}

    handleError(error: Error | HttpErrorResponse): void {
        if (error instanceof HttpErrorResponse) {
            // Error de servidor
            if (!navigator.onLine) {
                // Sin conexion a internet
                console.log('No tiene conexion a internet');
            }
            /**
             * Todo
             * Error Http
             * Retorna el error
             */
            console.log(`${error.status} -  ${error.message}`);
        } else {
            /**
             * Todo
             * Ocurre un error en el cliente
             * Se redirecciona a la pagina de error o retorno el mensaje de error personalizado y lo muestro
             */
            console.log(error);
        }
    }

}
